import React from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Shown while a lazy-loaded route chunk is downloading (see MainLayout / IframeLayout Suspense).
 */
export const RouteChunkFallback: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="route-chunk-fallback flex min-h-[40vh] w-full items-center justify-center p-8">
            <Spin size="large" description={t('common.loading')} />
        </div>
    );
};
